import { debounce } from '../utils';

let autoplay = null;

const setSlidesHeight = ($carousel) => {
    const $slides = $carousel.find('.quote-slides');
    const $slide = $carousel.find('.quote-slide');
    $slide.css('height', 'auto');
    const slideHeights = (
        $slides
            .children()
            .map((index, el) => $(el).height())
            .get()
    );
    const maxHeight = Math.max(...slideHeights)
    $slides.height(maxHeight);
    $slide.css('height', '100%');
};

const manageSlidesHeight = ($carousel) => {
    setSlidesHeight($carousel);
    $(window).resize(
        debounce(
            () => setSlidesHeight($carousel),
            100
        )
    );
};

const slideTo = ($carousel, index) => {
    const currentIndex = (
        $carousel
            .find('.slide-indicator.active')
            .index()
    );
    const indexDiff = index - currentIndex;
    const direction = indexDiff > 0 ? 1 : -1;
    const outClasses = ['-translate-x-full-plus', 'translate-x-full-plus'];
    const outClass = direction === 1 ? outClasses[0] : outClasses[1];

    $('.slide-indicator.active').removeClass('active');
    $('.slide-indicator').eq(index).addClass('active');

    $('.quote-slide.translate-x-0')
        .removeClass('translate-x-0')
        .addClass(outClass);

    if (Math.abs(indexDiff) > 1) {
        for (
            let i = currentIndex + direction;
            direction === 1 ? i < index : i > index;
            i += direction
        ) {
            $('.quote-slide')
                .eq(i)
                .removeClass(outClasses)
                .addClass(outClass);
        }
    }

    $('.quote-slide')
        .eq(index)
        .removeClass(outClasses)
        .addClass('translate-x-0');
};

const slideToNext = ($carousel) => {
    const count = $carousel.find('.quote-slide').length;
    const currentIndex = (
        $carousel
            .find('.slide-indicator.active')
            .index()
    );
    const nextIndex = (
        currentIndex === count - 1
            ? 0
            : currentIndex + 1
    );
    slideTo($carousel, nextIndex);
};

const slideToPrevious = ($carousel) => {
    const count = $carousel.find('.quote-slide').length;
    const currentIndex = (
        $carousel
            .find('.slide-indicator.active')
            .index()
    );
    const previousIndex = (
        currentIndex === 0
            ? count - 1
            : currentIndex - 1
    );
    slideTo($carousel, previousIndex);
};

const prepareSlideControls = ($carousel) => {
    $carousel.find('.slide-indicator').click(function(event) {
        event.preventDefault();
        clearInterval(autoplay);
        if ($(this).hasClass('active')) return;
        slideTo($carousel, $(this).index());
    });
    $carousel.find('.quote-slider-arrow').click(function(event) {
        event.preventDefault();
        clearInterval(autoplay);
        if ($(this).hasClass('quote-slider-arrow-next')) {
            slideToNext($carousel);
        } else {
            slideToPrevious($carousel);
        }
    });
};

const startAutoplay = ($carousel) => {
    autoplay = (
        setInterval(
            () => slideToNext($carousel),
            5000
        )
    );
};

const initialize = () => {
    $('.quote-slider').each(function() {
        manageSlidesHeight($(this));
        prepareSlideControls($(this));
        startAutoplay($(this));
    });
};

export default {
    initialize,
};

